// File: tos.js
//
// The Terms of Service page. Linked from the Sign Up page.
//
// The text below is a PLACEHOLDER — replace each <Section> with the
// real legal language before launch. To add or remove a section, just
// add/remove a <Section title="...">...</Section> block in the JSX.

import React from "react";
import { useNavigate } from "react-router-dom";

import logo from "./assets/512.png";
import { COLORS, THEME, pageBackground } from "./theme";

// Helper component for one numbered section (title + paragraph).
// Used over and over below so every section looks the same.
function Section({ title, children }) {
  return (
    <section className="mt-4">
      <h2
        className="text-base sm:text-lg font-extrabold"
        style={{ color: THEME.text }}
      >
        {title}
      </h2>
      <div
        className="mt-1 text-sm leading-6"
        style={{ color: "rgba(31,56,0,0.72)" }}
      >
        {children}
      </div>
    </section>
  );
}

function TOS() {
  const navigate = useNavigate();

  return (
    <div className="flex-1 relative flex flex-col" style={pageBackground}>
      <header
        className="sticky top-0 z-20 backdrop-blur border-b shadow-[0_6px_18px_rgba(31,56,0,0.16)]"
        style={{
          backgroundColor: THEME.headerBg,
          borderColor: "rgba(231,247,210,0.28)",
        }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-2 sm:py-3 flex items-center justify-between gap-3">
          <button
            onClick={() => navigate("/")}
            className="flex items-center gap-3 rounded-xl px-2 py-1 hover:bg-white/10 transition"
            aria-label="Go to landing page"
            type="button"
          >
            <img src={logo} alt="Logo" className="w-13 h-12 object-contain" />

            <div className="leading-tight text-left">
              <div className="text-sm font-extrabold text-white">
                H.O.P.E Navigator
              </div>
              <div
                className="text-[12px] font-semibold"
                style={{ color: COLORS.yellowLight }}
              >
                Terms of Service
              </div>
            </div>
          </button>

          <button
            onClick={() => navigate(-1)}
            className="text-sm font-extrabold text-white/90 hover:text-white transition rounded-xl px-3 py-2 hover:bg-white/10"
            type="button"
          >
            Back
          </button>
        </div>
      </header>

      <main className="flex-1 w-full max-w-3xl mx-auto px-4 sm:px-6 py-4 sm:py-6 lg:py-8">
        <section
          className="backdrop-blur border rounded-3xl p-5 sm:p-6 lg:p-8 max-h-[calc(100vh-100px)] sm:max-h-[calc(100vh-130px)] overflow-y-auto"
          style={{
            backgroundColor: THEME.cardBg,
            borderColor: THEME.border,
            boxShadow: THEME.shadow,
          }}
        >
          <div
            className="inline-flex items-center rounded-full px-3 py-1 text-sm font-extrabold"
            style={{ color: COLORS.brown }}
          >
            Terms of Service
          </div>

          <h1
            className="text-3xl sm:text-4xl font-extrabold mt-4 leading-tight"
            style={{ color: THEME.text }}
          >
            H.O.P.E Navigator Terms of Service
          </h1>

          <p
            className="mt-3 text-sm"
            style={{ color: "rgba(31,56,0,0.55)" }}
          >
            Placeholder content. Replace with the final terms before launch.
          </p>

          <Section title="1. Acceptance">
            By creating an account, you agree to these Terms of Service and the
            related privacy practices of Increasing H.O.P.E - Financial Training
            Center.
          </Section>

          <Section title="2. Use of the service">
            H.O.P.E Navigator is provided to help users access community resources,
            submit inquiries, and communicate with the Increasing H.O.P.E team.
            You agree to use the service lawfully and in good faith.
          </Section>

          <Section title="3. Not an emergency service">
            H.O.P.E Navigator is not an emergency service. The team aims to
            respond to inquiries within 24-48 hours but does not provide
            immediate crisis response. For urgent needs, use the resources in
            the resource directory or contact local emergency services.
          </Section>

          <Section title="4. Account information">
            You are responsible for maintaining the accuracy of the information
            in your account and for keeping your sign-in credentials secure.
          </Section>

          <Section title="5. Privacy">
            Personal information you provide is used to support your inquiries
            and account. The team does not sell user information. Replace this
            section with a link to the final privacy policy before launch.
          </Section>

          <Section title="6. Limitations">
            The service is provided "as is" without warranty of any kind.
            Increasing H.O.P.E is not liable for outcomes that fall outside
            its direct support.
          </Section>

          <Section title="7. Contact">
            Questions about these terms can be sent to{" "}
            <a
              href="mailto:financetraining@increasinghope.org"
              className="font-extrabold underline decoration-black/20 hover:decoration-black/40"
              style={{ color: COLORS.aquaDark }}
            >
              financetraining@increasinghope.org
            </a>
            .
          </Section>
        </section>
      </main>
    </div>
  );
}

export default TOS;
